import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  TextField,
  Button,
  Typography,
  MenuItem,
  Checkbox,
  FormControlLabel,
  CircularProgress,
  Grid,
  IconButton,
  InputAdornment,
  Snackbar,
  Alert,
  FormControl,
  Select,
} from "@mui/material";

import { Visibility, VisibilityOff } from "@mui/icons-material";
import { InputMask } from "@react-input/mask";

import api from "./api/api";
import { ENDPOINTS } from "./api/endpoints";
import leftimage from "./assets/login.png";
import Navigation from "./RootNavigation";
import Footer from "./Footer";
import { Link as RouterLink } from "react-router-dom";
import { Link } from "@mui/material";

export default function SignUp() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    accountType: "talent",
    fullName: "",
    unionsSelected: [],
    companyName: "",
    phone: "",
    email: "",
    username: "",
    password: "",
    confirmPassword: "",
    termsAgree: false,
  });

  const [unions, setUnions] = useState([]);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
const [checkingEmail, setCheckingEmail] = useState(false);
const [emailExists, setEmailExists] = useState(false);
const [checkingUsername, setCheckingUsername] = useState(false);
const [usernameExists, setUsernameExists] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [showConfirmPass, setShowConfirmPass] = useState(false);
  const showChecklist = formData.password.length > 0;

  // Toast
  const [toast, setToast] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const showToast = (message, severity = "success") =>
    setToast({ open: true, message, severity });
  const closeToast = () => setToast((p) => ({ ...p, open: false }));

  // ---------------- VALIDATION ----------------
  const validateEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) ? "" : "Invalid email format.";



  const getPasswordValidation = (password) => {
  return {
    length: password.length >= 8,
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    number: /[0-9]/.test(password),
    special: /[!@#$%^&*(),.?\":{}|<>]/.test(password),
  };
};
  const passwordValidation = getPasswordValidation(formData.password);
  // ----------- FETCH UNIONS -----------
  useEffect(() => {
    const fetchUnions = async () => {
      try {
        const res = await api.get(ENDPOINTS.getUnions());
        if (Array.isArray(res.data)) setUnions(res.data);
      } catch (error) {
        console.error("Union fetch error:", error);
      }
    };
    fetchUnions();
  }, []);

  // ------------- INPUT CHANGE -------------
const handleChange = (e) => {
  const { name, value, checked, type } = e.target;

  setFormData((p) => ({
    ...p,
    [name]: type === "checkbox" ? checked : value,
  }));

  if (name === "email") {
    setEmailExists(false);

    setErrors((prev) => {
      const updated = { ...prev };
      delete updated.email;
      return updated;
    });
  }
  if (name === "username") {
  setUsernameExists(false);

  setErrors((prev) => {
    const updated = { ...prev };
    delete updated.username;
    return updated;
  });
}
};
const checkUsernameExists = async (username) => {
  if (!username?.trim()) {
    setUsernameExists(false);
    return;
  }

  try {
    setCheckingUsername(true);

    const res = await api.get(
      ENDPOINTS.checkUserName(),
      {
        params: {
          userName: username
        }
      }
    );

    if (res.data?.status === "Ok") {
      if (res.data.userNameExists) {
        setUsernameExists(true);

        setErrors((prev) => ({
          ...prev,
          username: "Username already exists."
        }));
      } else {
        setUsernameExists(false);

        setErrors((prev) => {
          const updated = { ...prev };
          if (updated.username === "Username already exists.") {
            delete updated.username;
          }
          return updated;
        });
      }
    }
  } catch (err) {
    console.error("Username check failed", err);
  } finally {
    setCheckingUsername(false);
  }
};
  const checkEmailExists = async (email) => {
  if (!email || validateEmail(email)) {
    setEmailExists(false);
    return;
  }

  try {
    setCheckingEmail(true);

const res = await api.get(
  ENDPOINTS.checkEmail(),
  {
    params: {
      email,
    },
  }
);
    if (res.data?.status === "Ok") {
      if (res.data.emailExists) {
        setEmailExists(true);
        setErrors((prev) => ({
          ...prev,
          email: "Email already exists.",
        }));
      } else {
        setEmailExists(false);
        setErrors((prev) => {
          const updated = { ...prev };
          if (updated.email === "Email already exists.") {
            delete updated.email;
          }
          return updated;
        });
      }
    }
  } catch (err) {
    console.error("Email check failed", err);
  } finally {
    setCheckingEmail(false);
  }
};

  // ------------- SUBMIT ----------------
  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};

    // Required validations
    if (!formData.accountType) newErrors.accountType = "Required";
    if (!formData.fullName.trim()) newErrors.fullName = "Required";

    if (formData.accountType === "talent") {
      if (formData.unionsSelected.length === 0)
        newErrors.unionsSelected = "Select at least one";
    }

    if (formData.accountType === "creator" && !formData.companyName)
      newErrors.companyName = "Required";

    if (formData.accountType === "creator") {
      if (!formData.phone || formData.phone.replace(/\D/g, "").length !== 10)
        newErrors.phone = "Enter valid 10-digit number";
    }
    if (formData.username.length > 20) {
  newErrors.username = "Username cannot exceed 20 characters.";
}

    if (!formData.email) newErrors.email = "Required";
    const emailError = validateEmail(formData.email);
    if (emailError) newErrors.email = emailError;

    if (emailExists) {
  newErrors.email = "Email already exists.";
}

    if (!formData.username.trim()) newErrors.username = "Required";
    if (usernameExists) {
  newErrors.username = "Username already exists.";
}
const passValidation = getPasswordValidation(formData.password);
if (formData.confirmPassword && formData.password !== formData.confirmPassword) {
  newErrors.confirmPassword = "Passwords do not match";
}
const isPasswordValid = Object.values(passValidation).every(Boolean);

if (!isPasswordValid) {
newErrors.password = "Invalid password";
}

    if (!formData.termsAgree)
      newErrors.termsAgree = "Please accept terms and conditions";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    // ---- NAME SPLIT ----
    const cleanName = formData.fullName.trim().replace(/\s+/g, " ");
    const parts = cleanName.split(" ");
    const firstName = parts[0];
    const lastName = parts.slice(1).join(" ");

    // ---- FINAL PAYLOAD ----
    const payload = {
      firstName,
      lastName,
      email: formData.email,
      userName: formData.username,
      password: formData.password,
      accountType: formData.accountType === "creator" ? 9 : 2,
      affiliationName: formData.unionsSelected,

      companyName: formData.companyName || "",
      phone: formData.phone ? formData.phone.replace(/\D/g, "") : "",
    };

    try {
      setIsLoading(true);

      const res = await api.post(ENDPOINTS.addNewUserDetails(), payload);

      const success =
        res.data?.status?.toLowerCase() === "ok" ||
        res.data?.httpStatusCode === 200;

      if (success) {
        showToast("Account created successfully!", "success");
        localStorage.setItem("rememberedUsername", formData.username);
        setTimeout(() => navigate("/login"), 1500);
        return;
      }

      setErrors({ form: res.data?.message || "Unable to create account." });
    } catch (err) {
      const msg =
        err.response?.data?.message ||
        err.response?.data?.error ||
        err.message ||
        "Something went wrong";

      if (msg.toLowerCase().includes("email")) {
        setErrors((p) => ({ ...p, email: "Email already exists." }));
        return;
      }
      if (msg.toLowerCase().includes("user")) {
        setErrors((p) => ({ ...p, username: "Username already exists." }));
        return;
      }

      setErrors({ form: msg });
    } finally {
      setIsLoading(false);
    }
  };
  const handleAccountTypeChange = (type) => {
    setFormData((prev) => {
      const updated = { ...prev, accountType: type };

      if (type === "talent") {
        // Clear creator fields
        updated.companyName = "";
        updated.phone = "";
      }

      if (type === "creator") {
        // Clear talent fields
        updated.unionsSelected = [];
      }

      return updated;
    });

    // Clear related validation errors when switching
    setErrors((prev) => {
      const newErr = { ...prev };
      delete newErr.companyName;
      delete newErr.phone;
      delete newErr.unionsSelected;
      return newErr;
    });
  };

  // ---------------- UI -------------------
  return (
    <>
      <Navigation />
      <Box
        sx={{
          minHeight: "100vh",
          backgroundColor: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          py: 6,
        }}
      >
        <Snackbar
          open={toast.open}
          autoHideDuration={2500}
          onClose={closeToast}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert severity={toast.severity}>{toast.message}</Alert>
        </Snackbar>

        <Grid
          container
          sx={{
            maxWidth: 1200,
            backgroundColor: "#fff",
            overflow: "hidden",
            alignItems: "stretch",
          }}
        >
          {/* LEFT IMAGE */}
          <Grid
            item
            xs={12}
            md={5}
            sx={{
              display: "flex",
              justifyContent: "center", // horizontal center
              alignItems: "center", // vertical center
              p: 2,
              order: { xs: 2, md: 1 },
            }}
          >
            <Box
              component="img"
              src={leftimage}
              alt="left visual"
              sx={{
                maxWidth: "100%",
                maxHeight: "100%",
              }}
            />
          </Grid>
          {/* FORM */}
          <Grid
            item
            xs={12}
            md={7}
            sx={{
              px: { xs: 4, md: 6 },
              pb: { xs: 4, md: 6 },
              pt: 0,
              order: { xs: 1, md: 2 },
            }}
          >
            <Typography
              variant="h4"
              textAlign="center"
              sx={{ fontWeight: 600 }}
            >
              Create Account
            </Typography>

            <form onSubmit={handleSubmit}>
              {/* ACCOUNT TYPE */}
              {/* ACCOUNT TYPE BUTTONS */}
              <Box sx={{ mt: 2 }}>
                <Typography variant="h6">
                  Choose the type of account to create{" "}
                </Typography>
                <Typography sx={{ pb: 1 }}>
                  If you already have an account on NYCastings,{" "}
                  <Link
                    component={RouterLink}
                    to="/login"
                    sx={{ color: "#90b5fe", cursor: "pointer" }}
                  >
                    login here
                  </Link>
                </Typography>
                <Box sx={{ display: "flex", gap: 2 }}>
                  <Button
                    variant={
                      formData.accountType === "talent"
                        ? "contained"
                        : "outlined"
                    }
                    sx={{
                      flex: 1,
                      backgroundColor:
                        formData.accountType === "talent"
                          ? "#202020"
                          : "transparent",
                      color:
                        formData.accountType === "talent" ? "#fff" : "black",
                      borderColor: "#202020",
                      "&:hover": {
                        backgroundColor: "#202020",
                        borderColor: "#202020",
                        color: "#fff",
                      },
                    }}
                    onClick={() => handleAccountTypeChange("talent")}
                  >
                    Talent
                  </Button>

                  <Button
                    variant={
                      formData.accountType === "creator"
                        ? "contained"
                        : "outlined"
                    }
                    sx={{
                      flex: 1,
                      backgroundColor:
                        formData.accountType === "creator"
                          ? "#202020"
                          : "transparent",
                      color:
                        formData.accountType === "creator" ? "#fff" : "black",
                      borderColor: "#202020",
                      "&:hover": {
                        backgroundColor: "#202020",
                        borderColor: "#202020",
                        color: "#fff",
                      },
                    }}
                    onClick={() => handleAccountTypeChange("creator")}
                  >
                    Casting Director / Creator
                  </Button>
                </Box>

                {errors.accountType && (
                  <Typography color="error" variant="body2" sx={{ mt: 1 }}>
                    {errors.accountType}
                  </Typography>
                )}
              </Box>

              {/* FULL NAME */}
              <TextField
                label="Full Name *"
                name="fullName"
                fullWidth
                margin="normal"
                value={formData.fullName}
                onChange={handleChange}
                error={!!errors.fullName}
                helperText={errors.fullName}
              />

              {/* UNION MULTI SELECT */}
              {formData.accountType === "talent" && (
                <FormControl fullWidth margin="normal">
                  <Typography sx={{ mb: 0.6, fontWeight: 500 }}>
                    Union Affiliation *
                  </Typography>

                  <TextField
                    select
                    SelectProps={{
                      multiple: true,
                      renderValue: (selected) => {
                        if (selected.length === 0) {
                          return (
                            <span style={{ color: "#888" }}>
                              Select Union(s)
                            </span>
                          );
                        }

                        return selected
                          .map(
                            (id) =>
                              unions.find((x) => x.affiliationId === id)
                                ?.affiliationName,
                          )
                          .join(", ");
                      },
                      MenuProps: {
                        PaperProps: {
                          style: { maxHeight: 260 },
                        },
                      },
                    }}
                    name="unionsSelected"
                    value={formData.unionsSelected}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        unionsSelected: e.target.value,
                      }))
                    }
                    error={!!errors.unionsSelected}
                    helperText={errors.unionsSelected}
                    fullWidth
                    inputProps={{
                      sx: {
                        height: "45px",
                        display: "flex",
                        alignItems: "center",
                      },
                    }}
                  >
                    {unions.map((u) => (
                      <MenuItem key={u.affiliationId} value={u.affiliationId}>
                        <Checkbox
                          checked={formData.unionsSelected.includes(
                            u.affiliationId,
                          )}
                        />
                        <Typography>{u.affiliationName}</Typography>
                      </MenuItem>
                    ))}
                  </TextField>
                </FormControl>
              )}

              {/* COMPANY + PHONE */}
              {formData.accountType === "creator" && (
                <>
                  <TextField
                    label="Company Name *"
                    name="companyName"
                    fullWidth
                    margin="normal"
                    value={formData.companyName}
                    onChange={handleChange}
                    error={!!errors.companyName}
                    helperText={errors.companyName}
                  />

                  <InputMask
                    mask="(000) 000-0000"
                    replacement={{ 0: /\d/ }}
                    value={formData.phone}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        phone: e.target.value,
                      }))
                    }
                    component={TextField}
                    label="Phone *"
                    fullWidth
                    margin="normal"
                    error={!!errors.phone}
                    helperText={errors.phone}
                  />
                </>
              )}

              {/* EMAIL */}
             <TextField
  label="Email *"
  name="email"
  fullWidth
  margin="normal"
  value={formData.email}
  onChange={handleChange}
  onBlur={() => checkEmailExists(formData.email)}
  error={!!errors.email}
  helperText={
    checkingEmail
      ? "Checking email..."
      : errors.email
  }
/>
              {/* USERNAME */}
<TextField
  label="Username *"
  name="username"
  fullWidth
  margin="normal"
  value={formData.username}
  onChange={handleChange}
  onBlur={() => checkUsernameExists(formData.username)}
  error={!!errors.username}
  helperText={
    checkingUsername
      ? "Checking username..."
      : errors.username
  }
  inputProps={{ maxLength: 20 }}
/>

              {/* PASSWORD */}
             <TextField
  label="Password *"
  name="password"
  type={showPass ? "text" : "password"}
  fullWidth
  margin="normal"
  value={formData.password}
  onChange={handleChange}
  error={!!errors.password}
  InputProps={{
    endAdornment: (
      <InputAdornment position="end">
        <IconButton onClick={() => setShowPass(!showPass)}>
          {showPass ? <VisibilityOff /> : <Visibility />}
        </IconButton>
      </InputAdornment>
    ),
  }}
/>
{/* PASSWORD CHECKLIST */}
{showChecklist && (
  <Box sx={{ mt: 1, ml: 1 }}>
    {[
      { label: "At least 8 characters", valid: passwordValidation.length },
      { label: "One uppercase letter", valid: passwordValidation.uppercase },
      { label: "One lowercase letter", valid: passwordValidation.lowercase },
      { label: "One number", valid: passwordValidation.number },
      { label: "One special character", valid: passwordValidation.special },
    ].map((item, index) => (
      <Typography
        key={index}
        sx={{
          fontSize: "0.85rem",
          color: item.valid ? "green" : "#999",
        }}
      >
        {item.valid ? "✔" : "○"} {item.label}
      </Typography>
    ))}
  </Box>
)}

              {/* CONFIRM PASSWORD */}
              <TextField
                label="Confirm Password *"
                name="confirmPassword"
                type={showConfirmPass ? "text" : "password"}
                fullWidth
                margin="normal"
                value={formData.confirmPassword}
                onChange={handleChange}
                error={!!errors.confirmPassword}
                helperText={errors.confirmPassword}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowConfirmPass(!showConfirmPass)}
                      >
                        {showConfirmPass ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              {/* TERMS */}

              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.termsAgree}
                    onChange={handleChange}
                    name="termsAgree"
                  />
                }
                label={
                  <Typography sx={{ color: "text.primary" }}>
                    I agree to the{" "}
                    <Link
                      component={RouterLink}
                      to="/terms-and-condition"
                      sx={{
                        color: "#90b5fe !important",
                      }}
                    >
                      Terms and Conditions
                    </Link>{" "}
                    and{" "}
                    <Link
                      component={RouterLink}
                      to="/privacy-policy"
                      sx={{
                        color: "#90b5fe !important",
                      }}
                    >
                      Privacy Policy
                    </Link>
                  </Typography>
                }
              />

              {errors.termsAgree && (
                <Typography color="error" variant="body2">
                  {errors.termsAgree}
                </Typography>
              )}

              {/* FORM LEVEL ERROR */}
              {errors.form && (
                <Typography color="error" textAlign="center">
                  {errors.form}
                </Typography>
              )}

              {/* SUBMIT */}
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 2, backgroundColor: "#90b5fe" }}
disabled={
  isLoading ||
  checkingEmail ||
  checkingUsername ||
  emailExists ||
  usernameExists
}
              >
                {isLoading ? <CircularProgress size={24} /> : "Sign Up"}
              </Button>

              {/*     <Typography textAlign="center" sx={{ mt: 2 }}>
                Already a member?{" "}
<Link
  component={RouterLink}
  to="/login"
  sx={{ color: "#90b5fe", cursor: "pointer" }}
>
                  Log in
                </Link>
              </Typography> */}
            </form>
          </Grid>
        </Grid>
      </Box>
      <Footer />
    </>
  );
}
